"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prequalType = exports["default"] = void 0;
var prequalType = 'PrequalCreditCard';
exports.prequalType = prequalType;

var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      offerType = _ref.__typename;

  return offerType === prequalType;
};

exports["default"] = _default;
//# sourceMappingURL=is-offer-prequal.js.map